import {
    FundDeleteTxParams,
    FundDeployTxParams,
    FundDepositTxParams,
    FundHoldingCreateParams,
    FundReIndexingTxParams,
    FundUpdateTxParams,
    FundWithdrawTxParams,
    toJson,
    WalletTxParams,
} from '../../Commons';
import { FundEntity } from '../../Entities/Fund.Entity';
import { SmartDBTxApiCalls } from '../index.exports.BtnHandlers.TxApiCalls';
import { fetchWrapper } from '../../lib/index.exports';

export class FundTxApiCalls extends SmartDBTxApiCalls {
    protected static _Entity = FundEntity;

    // #region class methods

    // #endregion class methods

    // #region api tx

    public static async deployTxApi(walletTxParams: WalletTxParams, txParams: FundDeployTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `FundDeployTxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/deploy`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - deployTxApi - data: ${data} - response OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - deployTxApi - Error: ${error}`);
            throw error;
        }
    }

    public static async depositTxApi(walletTxParams: WalletTxParams, txParams: FundDepositTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `FundDeployTxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/deposit`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - depositTxApi - response OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - depositTxApi - Error: ${error}`);
            throw error;
        }
    }

    public static async withdrawTxApi(walletTxParams: WalletTxParams, txParams: FundWithdrawTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `FundDeployTxParams not defined`;
            }
            const body = toJson({ walletTxParams: walletTxParams, txParams: txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/withdraw`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - withdrawTxApi - response OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - withdrawTxApi - Error: ${error}`);
            throw error;
        }
    }

    public static async updateTxApi(walletTxParams: WalletTxParams, txParams: FundUpdateTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `FundUpdateTxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/update`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - updateTxApi - response OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - updateTxApi - Error: ${error}`);
            throw error;
        }
    }

    public static async addFundHoldingTxApi(walletTxParams: WalletTxParams, txParams: FundHoldingCreateParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `FundHoldingCreateParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/add-fund-holding`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - fundAddFundHoldingTxApi - respons OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - fundAddFundHoldingTxApi - Error: ${error}`);
            throw error;
        }
    }

    public static async reIndexingTxApi(walletTxParams: WalletTxParams, txParams: FundReIndexingTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `FundDeployTxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/re-indexing`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - reIndexingTxApi - response OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - reIndexingTxApi - Error: ${error}`);
            throw error;
        }
    }

    public static async deleteTxApi(params: FundDeleteTxParams): Promise<any> {
        try {
            if (params === undefined) {
                throw `FundDeleteTxParams not defined`;
            }
            const body = toJson(params);
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/delete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - deleteTxApi - response OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - deleteTxApi - Error: ${error}`);
            throw error;
        }
    }

    // #endregion api tx
}
